// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home' // 默认重定向到第一页
  },
  {
    path: '/home',
    name: 'HomePage',
    component: () => import('../views/home-page.vue')
  },
  {
    path: '/home-2',
    name: 'HomePage2',
    component: () => import('../views/home-page-2.vue')
  },
  {
    path: '/home-3',
    name: 'HomePage3',
    component: () => import('../views/home-page-3.vue')
  },
  {
    path: '/home-4',
    name: 'HomePage4',
    component: () => import('../views/home-page-4.vue')
  },
  {
    path: '/detail',
    name: 'DetailPage',
    component: () => import('../views/detail-page.vue')
  },
  {
    path: '/detail-2',
    name: 'DetailPage2',
    component: () => import('../views/detail-page-2.vue')
  },
  {
    path: '/detail-3',
    name: 'DetailPage3',
    component: () => import('../views/detail-page-3.vue')
  },
  {
    path: '/detail-4',
    name: 'DetailPage4',
    component: () => import('../views/detail-page-4.vue')
  },
  {
    path: '/forest',
    name: 'ForestPage',
    component: () => import('../views/forest-page.vue')
  },
  {
    path: '/forest-2',
    name: 'ForestPage2',
    component: () => import('../views/forest-page-2.vue')
  },
  {
    path: '/forest-3',
    name: 'ForestPage3',
    component: () => import('../views/forest-page-3.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router